import { useState, useEffect } from 'react';

export interface UseClientIdResult {
  clientId: string | null;
  isValidClient: boolean;
  error: string | null;
}

/**
 * Hook for extracting client_id from URL parameters
 * A client is considered valid if client_id is provided in the URL
 */
export const useClientId = (): UseClientIdResult => {
  const [clientId, setClientId] = useState<string | null>(null);
  const [isValidClient, setIsValidClient] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const extractClientId = () => {
      setError(null);

      try {
        // Extract client_id from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const extractedClientId = urlParams.get('client_id');

        if (!extractedClientId) {
          setError('unsupportedClient.errors.clientIdRequired');
          setIsValidClient(false);
          setClientId(null);
        } else {
          setClientId(extractedClientId);
          setIsValidClient(true);
          setError(null);
        }
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'unsupportedClient.errors.extractFailed';
        setError(errorMessage);
        setIsValidClient(false);
        setClientId(null);
      }
    };

    extractClientId();
  }, []);

  return {
    clientId,
    isValidClient,
    error
  };
};